/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchResultsRouteImport } from './routes/searchResults'
import { Route as EnCookiesRouteImport } from './routes/en/cookies'
import { Route as EnTermsOfServiceRouteImport } from './routes/en/termsOfService'
import { Route as EnTermsOfServiceLUXRouteImport } from './routes/en/termsOfServiceLUX'
import { Route as FrCookiesRouteImport } from './routes/fr/cookies'
import { Route as FrTermsOfServiceRouteImport } from './routes/fr/termsOfService'
import { Route as FrTermsOfServiceLUXRouteImport } from './routes/fr/termsOfServiceLUX'

const IndexLazyRouteImport = createFileRoute('/')()
const RootIdLazyRouteImport = createFileRoute('/root/$id')()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const SearchResultsRoute = SearchResultsRouteImport.update({
  id: '/searchResults',
  path: '/searchResults',
  getParentRoute: () => rootRouteImport,
} as any)
const EnCookiesRoute = EnCookiesRouteImport.update({
  id: '/en/cookies',
  path: '/en/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const EnTermsOfServiceRoute = EnTermsOfServiceRouteImport.update({
  id: '/en/termsOfService',
  path: '/en/termsOfService',
  getParentRoute: () => rootRouteImport,
} as any)
const EnTermsOfServiceLUXRoute = EnTermsOfServiceLUXRouteImport.update({
  id: '/en/termsOfServiceLUX',
  path: '/en/termsOfServiceLUX',
  getParentRoute: () => rootRouteImport,
} as any)
const FrCookiesRoute = FrCookiesRouteImport.update({
  id: '/fr/cookies',
  path: '/fr/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const FrTermsOfServiceRoute = FrTermsOfServiceRouteImport.update({
  id: '/fr/termsOfService',
  path: '/fr/termsOfService',
  getParentRoute: () => rootRouteImport,
} as any)
const FrTermsOfServiceLUXRoute = FrTermsOfServiceLUXRouteImport.update({
  id: '/fr/termsOfServiceLUX',
  path: '/fr/termsOfServiceLUX',
  getParentRoute: () => rootRouteImport,
} as any)
const RootIdLazyRoute = RootIdLazyRouteImport.update({
  id: '/root/$id',
  path: '/root/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/root/$id.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/searchResults': typeof SearchResultsRoute
  '/en/cookies': typeof EnCookiesRoute
  '/en/termsOfService': typeof EnTermsOfServiceRoute
  '/en/termsOfServiceLUX': typeof EnTermsOfServiceLUXRoute
  '/fr/cookies': typeof FrCookiesRoute
  '/fr/termsOfService': typeof FrTermsOfServiceRoute
  '/fr/termsOfServiceLUX': typeof FrTermsOfServiceLUXRoute
  '/root/$id': typeof RootIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/searchResults': typeof SearchResultsRoute
  '/en/cookies': typeof EnCookiesRoute
  '/en/termsOfService': typeof EnTermsOfServiceRoute
  '/en/termsOfServiceLUX': typeof EnTermsOfServiceLUXRoute
  '/fr/cookies': typeof FrCookiesRoute
  '/fr/termsOfService': typeof FrTermsOfServiceRoute
  '/fr/termsOfServiceLUX': typeof FrTermsOfServiceLUXRoute
  '/root/$id': typeof RootIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/searchResults': typeof SearchResultsRoute
  '/en/cookies': typeof EnCookiesRoute
  '/en/termsOfService': typeof EnTermsOfServiceRoute
  '/en/termsOfServiceLUX': typeof EnTermsOfServiceLUXRoute
  '/fr/cookies': typeof FrCookiesRoute
  '/fr/termsOfService': typeof FrTermsOfServiceRoute
  '/fr/termsOfServiceLUX': typeof FrTermsOfServiceLUXRoute
  '/root/$id': typeof RootIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/searchResults'
    | '/en/cookies'
    | '/en/termsOfService'
    | '/en/termsOfServiceLUX'
    | '/fr/cookies'
    | '/fr/termsOfService'
    | '/fr/termsOfServiceLUX'
    | '/root/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/searchResults'
    | '/en/cookies'
    | '/en/termsOfService'
    | '/en/termsOfServiceLUX'
    | '/fr/cookies'
    | '/fr/termsOfService'
    | '/fr/termsOfServiceLUX'
    | '/root/$id'
  id:
    | '__root__'
    | '/'
    | '/searchResults'
    | '/en/cookies'
    | '/en/termsOfService'
    | '/en/termsOfServiceLUX'
    | '/fr/cookies'
    | '/fr/termsOfService'
    | '/fr/termsOfServiceLUX'
    | '/root/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  SearchResultsRoute: typeof SearchResultsRoute
  EnCookiesRoute: typeof EnCookiesRoute
  EnTermsOfServiceRoute: typeof EnTermsOfServiceRoute
  EnTermsOfServiceLUXRoute: typeof EnTermsOfServiceLUXRoute
  FrCookiesRoute: typeof FrCookiesRoute
  FrTermsOfServiceRoute: typeof FrTermsOfServiceRoute
  FrTermsOfServiceLUXRoute: typeof FrTermsOfServiceLUXRoute
  RootIdLazyRoute: typeof RootIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/searchResults': {
      id: '/searchResults'
      path: '/searchResults'
      fullPath: '/searchResults'
      preLoaderRoute: typeof SearchResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/cookies': {
      id: '/en/cookies'
      path: '/en/cookies'
      fullPath: '/en/cookies'
      preLoaderRoute: typeof EnCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/termsOfService': {
      id: '/en/termsOfService'
      path: '/en/termsOfService'
      fullPath: '/en/termsOfService'
      preLoaderRoute: typeof EnTermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/termsOfServiceLUX': {
      id: '/en/termsOfServiceLUX'
      path: '/en/termsOfServiceLUX'
      fullPath: '/en/termsOfServiceLUX'
      preLoaderRoute: typeof EnTermsOfServiceLUXRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/cookies': {
      id: '/fr/cookies'
      path: '/fr/cookies'
      fullPath: '/fr/cookies'
      preLoaderRoute: typeof FrCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/termsOfService': {
      id: '/fr/termsOfService'
      path: '/fr/termsOfService'
      fullPath: '/fr/termsOfService'
      preLoaderRoute: typeof FrTermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/termsOfServiceLUX': {
      id: '/fr/termsOfServiceLUX'
      path: '/fr/termsOfServiceLUX'
      fullPath: '/fr/termsOfServiceLUX'
      preLoaderRoute: typeof FrTermsOfServiceLUXRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/root/$id': {
      id: '/root/$id'
      path: '/root/$id'
      fullPath: '/root/$id'
      preLoaderRoute: typeof RootIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  SearchResultsRoute: SearchResultsRoute,
  EnCookiesRoute: EnCookiesRoute,
  EnTermsOfServiceRoute: EnTermsOfServiceRoute,
  EnTermsOfServiceLUXRoute: EnTermsOfServiceLUXRoute,
  FrCookiesRoute: FrCookiesRoute,
  FrTermsOfServiceRoute: FrTermsOfServiceRoute,
  FrTermsOfServiceLUXRoute: FrTermsOfServiceLUXRoute,
  RootIdLazyRoute: RootIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
